const merge = (target, source) => {
    if (!target || !source) {
        return target;
    }
    for (let i in source) {
        if (source.hasOwnProperty(i)) {
            target[i] = source[i];
        }
    }
    return target;
};

export default function extend(target, ...args) {
    args.forEach(arg => {
        merge(target, arg);
    });
    return target;
}

